import { useState } from 'react'
import { useMutation } from '@apollo/client/react'
import { Modal, Button, Group, Stack, Text, Alert } from '@mantine/core'
import { IconCheck, IconAlertCircle } from '@tabler/icons-react'
import SendVerification from '../graphql/queries/SendVerification'

export default function UnverifiedAccountModal({ opened, onClose, email, ...props }) {
    const [emailSent, setEmailSent] = useState(false)
    const [message, setMessage] = useState('')
    const [messageType, setMessageType] = useState('success')

    const [sendVerificationMutation, { loading }] = useMutation(SendVerification)

    async function resendEmail() {
        const addr = email || localStorage.getItem('email')
        if (!addr) {
            setMessage('Could not determine your email address. Please try again from your profile settings.')
            setMessageType('error')
            return
        }
        try {
            const response = await sendVerificationMutation({ variables: { email: addr } })
            if (response.data?.sendVerification) {
                setEmailSent(true)
                setMessage('Verification email sent! Please check your inbox.')
                setMessageType('success')
            } else {
                setMessage('Failed to send verification email. Please try again later.')
                setMessageType('error')
            }
        } catch (err) {
            setMessage(err.message)
            setMessageType('error')
        }
    }

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Verify Your Email"
            centered
            {...props}
        >
            <Stack gap="md" style={{ marginTop: '1em' }}>
                <Text size="sm">
                    Welcome! Your account has been created and you're now logged in.
                </Text>
                <Text size="sm">
                    To unlock all features — like creating rooms — please verify your email address.
                    Check your inbox for a verification link and click it to complete the process.
                </Text>

                {message && (
                    <Alert
                        color={messageType === 'success' ? 'green' : 'red'}
                        variant="light"
                        icon={messageType === 'success' ? <IconCheck size={16} /> : <IconAlertCircle size={16} />}
                    >
                        {message}
                    </Alert>
                )}

                <Group justify="space-between" mt="xs">
                    <Button
                        variant="light"
                        disabled={loading || emailSent}
                        loading={loading}
                        onClick={resendEmail}
                    >
                        Resend Verification Email
                    </Button>
                    <Button onClick={onClose}>
                        OK
                    </Button>
                </Group>
            </Stack>
        </Modal>
    )
}

